<template>
  <div class="well offer" bis_skin_checked="1">
                             <div class="flex flex-wrap " bis_skin_checked="1">
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Nr. zlecenia:</strong><br> PRYWATA
                                </div>
                                 <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                     <strong>Status:</strong><br>
                                     <div class="status-rents1517" bis_skin_checked="1"><span style="color:green;">Wolny</span></div>
                                 </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Data wynajmu:</strong><br> 30/01/2019 12:00
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Data zwrotu:</strong><br> 01/12/2022 22:00
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Samochód:</strong><br> KIA OPTIMA <span class="carid">WU4136G-WOT81475</span>
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Licznik:</strong><br> 15002
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Wynajmujący:</strong><br> <a data-client-id="123" style="cursor:pointer;" class="show-client-modal">łukasz ignaciuk</a><br>

                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Cena/Dobę:</strong><br> 130 zł
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Adres podstawienia:</strong><br> jatne
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Adres zwrotu: </strong><br>
                                        
                                </div>
                                 <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                     <strong>Docelowy adres zwrotu: </strong><br>
                                         Jatne
                                 </div>
                                <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                                    <strong>Uwagi/Kaucja:</strong><br> PRYWATAod 19.11.19 wymiana z wu4136g1 10.01.20 WYMIANA Z 7036H<br>
                                </div>
                                <div class="md:w-1/5 pr-4 pl-4 co-xs-6" style="margin-top:10px;" bis_skin_checked="1">
                                    <a class="btn-rents1517 inline-block align-middle text-center select-none border font-normal whitespace-no-wrap rounded  no-underline py-1 px-2 leading-tight text-xs  bg-blue-600 text-white hover:bg-blue-600 btn-margin" href="http://wynajmy.drogowa.waw.pl/rents/1517/edit"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> </a>
                                    <a data-href="http://wynajmy.drogowa.waw.pl/rents/1517/delete" class="btn-rents1517 inline-block align-middle text-center select-none border font-normal whitespace-no-wrap rounded  no-underline py-1 px-2 leading-tight text-xs  bg-red-600 text-white hover:bg-red-700 btn-margin deletable"><i class="fa fa-trash-o"></i> </a>
                                    <a style="margin-top:5px;" href="http://wynajmy.drogowa.waw.pl/files/1517" class="inline-block align-middle text-center select-none border font-normal whitespace-no-wrap rounded py-1 px-3 leading-normal no-underline btn-xs bg-teal-500 text-white hover:bg-teal-600 btn-margin">Załączniki </a>
                                </div>
                             </div>
                        </div>
  <p>nowy komponent</p>
  <div
    class="flex flex-col md:flex-row md:items-center"
    :class="{
      'py-3 border-b border-gray-200 dark:border-gray-700':
        shouldShowCheckBoxes ||
        shouldShowDeleteMenu ||
        softDeletes ||
        !viaResource ||
        hasFilters ||
        haveStandaloneActions,
    }"
  >
    <div class="flex items-center flex-1">
      <div class="md:ml-3">
        <SelectAllDropdown
          v-if="shouldShowCheckBoxes"
          :all-matching-resource-count="allMatchingResourceCount"
          @toggle-select-all="toggleSelectAll"
          @toggle-select-all-matching="toggleSelectAllMatching"
        />
      </div>

      <!-- Toolbar Items -->
      <div class="h-9 ml-auto flex items-center pr-2 md:pr-3">
        <!-- Action Selector -->
        <div class="hidden md:flex px-2">
          <ActionSelector
            v-if="shouldShowActionSelector"
            :resource-name="resourceName"
            :actions="availableActions"
            :pivot-actions="pivotActions"
            :pivot-name="pivotName"
            :endpoint="actionsEndpoint"
            :action-query-string="actionQueryString"
            :selected-resources="selectedResourcesForActionSelector"
            @actionExecuted="getResources"
          />
        </div>

        <!-- Resource Polling -->
        <ResourcePollingButton
          v-if="shouldShowPollingToggle"
          :currently-polling="currentlyPolling"
          @start-polling="$emit('start-polling')"
          @stop-polling="$emit('stop-polling')"
        />

        <!-- Lenses -->
        <LensSelector
          v-if="lenses"
          :resource-name="resourceName"
          :lenses="lenses"
        />

        <!-- Filters -->
        <FilterMenu
          :resource-name="resourceName"
          :soft-deletes="softDeletes"
          :via-resource="viaResource"
          :via-has-one="viaHasOne"
          :trashed="trashed"
          :per-page="perPage"
          :per-page-options="filterPerPageOptions"
          @clear-selected-filters="clearSelectedFilters(lens || null)"
          @filter-changed="filterChanged"
          @trashed-changed="trashedChanged"
          @per-page-changed="updatePerPageChanged"
        />

        <DeleteMenu
          class="flex"
          v-if="shouldShowDeleteMenu"
          dusk="delete-menu"
          :soft-deletes="softDeletes"
          :resources="resources"
          :selected-resources="selectedResources"
          :via-many-to-many="viaManyToMany"
          :all-matching-resource-count="allMatchingResourceCount"
          :all-matching-selected="selectAllMatchingChecked"
          :authorized-to-delete-selected-resources="
            authorizedToDeleteSelectedResources
          "
          :authorized-to-force-delete-selected-resources="
            authorizedToForceDeleteSelectedResources
          "
          :authorized-to-delete-any-resources="authorizedToDeleteAnyResources"
          :authorized-to-force-delete-any-resources="
            authorizedToForceDeleteAnyResources
          "
          :authorized-to-restore-selected-resources="
            authorizedToRestoreSelectedResources
          "
          :authorized-to-restore-any-resources="authorizedToRestoreAnyResources"
          @deleteSelected="deleteSelectedResources"
          @deleteAllMatching="deleteAllMatchingResources"
          @forceDeleteSelected="forceDeleteSelectedResources"
          @forceDeleteAllMatching="forceDeleteAllMatchingResources"
          @restoreSelected="restoreSelectedResources"
          @restoreAllMatching="restoreAllMatchingResources"
          @close="closeDeleteModal"
          :trashed-parameter="trashedParameter"
        />
      </div>
    </div>

    <!-- Mobile Action Selector -->
    <div
      v-if="shouldShowActionSelector"
      class="flex items-center md:hidden px-2 pt-3 mt-2 md:mt-0 border-t border-gray-200 dark:border-gray-700"
    >
      <ActionSelector
        width="full"
        :resource-name="resourceName"
        :actions="availableActions"
        :pivot-actions="pivotActions"
        :pivot-name="pivotName"
        :endpoint="actionsEndpoint"
        :action-query-string="actionQueryString"
        :selected-resources="selectedResourcesForActionSelector"
        @actionExecuted="getResources"
      />
    </div>
  </div>
</template>

<script>
export default {
  emits: ['start-polling', 'stop-polling'],

  props: [
    'actionsEndpoint',
    'actionQueryString',
    'allMatchingResourceCount',
    'authorizedToDeleteAnyResources',
    'authorizedToDeleteSelectedResources',
    'authorizedToForceDeleteAnyResources',
    'authorizedToForceDeleteSelectedResources',
    'authorizedToRestoreAnyResources',
    'authorizedToRestoreSelectedResources',
    'availableActions',
    'clearSelectedFilters',
    'closeDeleteModal',
    'currentlyPolling',
    'deleteAllMatchingResources',
    'deleteSelectedResources',
    'filterChanged',
    'forceDeleteAllMatchingResources',
    'forceDeleteSelectedResources',
    'getResources',
    'hasFilters',
    'haveStandaloneActions',
    'lenses',
    'lens',
    'isLensView',
    'perPage',
    'perPageOptions',
    'pivotActions',
    'pivotName',
    'resources',
    'resourceInformation',
    'resourceName',
    'restoreAllMatchingResources',
    'restoreSelectedResources',
    'selectAllChecked',
    'selectAllMatchingChecked',
    'selectedResources',
    'selectedResourcesForActionSelector',
    'shouldShowActionSelector',
    'shouldShowCheckBoxes',
    'shouldShowDeleteMenu',
    'shouldShowPollingToggle',
    'softDeletes',
    'toggleSelectAll',
    'toggleSelectAllMatching',
    'trashed',
    'trashedChanged',
    'trashedParameter',
    'updatePerPageChanged',
    'viaHasOne',
    'viaManyToMany',
    'viaResource',
  ],

  computed: {
    filterPerPageOptions() {
      if (this.resourceInformation) {
        return this.perPageOptions || this.resourceInformation.perPageOptions
      }
    },
  },
}
</script>
